import { render, staticRenderFns } from "./ShipMember.vue?vue&type=template&id=1c71c48d&"
import script from "./ShipMember.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShipMember.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports